import { render, staticRenderFns } from "./SearchChipsContainer.vue?vue&type=template&id=2ae16caa&scoped=true"
import script from "./SearchChipsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchChipsContainer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae16caa",
  null
  
)

export default component.exports